export const CREATE_ACCOUNTS = 'CREATE_ACCOUNTS'
export const UPDATE_ACCOUNTS = 'UPDATE_ACCOUNTS'
export const CHANGE_THRESHOLD = 'CHANGE_THRESHOLD'
export const CLEAR = 'CLEAR'
export const GET_RETESTS = 'GET_RETESTS'
export const GET_RETEST_REASONS = 'GET_RETEST_REASONS'

export default {
  CREATE_ACCOUNTS,
  UPDATE_ACCOUNTS,
  CHANGE_THRESHOLD,
  CLEAR,
  GET_RETESTS,
  GET_RETEST_REASONS
}
